var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleOutline24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.667-3.667h53.334v53.334H-3.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 .778C10.733.778.778 10.733.778 23c0 12.267 9.955 22.222 22.222 22.222 12.267 0 22.222-9.955 22.222-22.222C45.222 10.733 35.267.778 23 .778zm0 40C13.2 40.778 5.222 32.8 5.222 23 5.222 13.2 13.2 5.222 23 5.222c9.8 0 17.778 7.978 17.778 17.778 0 9.8-7.978 17.778-17.778 17.778zm10.2-27.6L18.556 27.822 12.8 22.09l-3.133 3.133 8.889 8.89 17.777-17.779-3.133-3.155z",
    fill: "#007F00",
    fillRule: "nonzero"
  }))));
}
export default SvgCheckCircleOutline24Dp;